import type { Variable } from "@circle-react-uikit/InsertVariableButton/InsertVariableButtonWrapper";
import type { Editor } from "@tiptap/react";
import find from "lodash/find";
import { useRef } from "react";

interface UseVariableNodeProps {
  editor?: Editor;
  variables: Variable[];
}

type OnInsertVariable = (value: string) => boolean;

export const useVariableNode = ({
  editor,
  variables,
}: UseVariableNodeProps) => {
  const onInsertVariableRef = useRef<OnInsertVariable | null>(null); // Prevent stale values in callbacks

  onInsertVariableRef.current = value => {
    if (!editor) return false;
    if (!("insertVariable" in editor.commands)) return false; // Extension not enabled

    const variable = find(variables, { value });
    if (!variable) return false;
    return editor.chain().focus().insertVariable(value).run();
  };

  const onInsertVariable: OnInsertVariable = value =>
    onInsertVariableRef.current?.(value) ?? false;

  return { onInsertVariable };
};
